import { Workbook } from 'exceljs';
function formatTimestamp(date) {
    const pad = (n) => String(n).padStart(2, '0');
    const yyyy = date.getFullYear();
    const mm = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mi = pad(date.getMinutes());
    const ss = pad(date.getSeconds());
    return `${yyyy}${mm}${dd}${hh}${mi}${ss}`;
}
function styleHeader(row) {
    row.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF6B7280' },
        };
    });
}
function styleTotalRow(row) {
    ['E', 'F'].forEach(col => {
        const cell = row.getCell(col);
        cell.font = { bold: true };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE5E7EB' },
        };
    });
}
export default async function exportChargeReportToExcel(reports, fileName) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Rapport');
    worksheet.columns = [
        { header: 'Date', key: 'Date' },
        { header: 'Utilisateur', key: 'Utilisateur' },
        { header: 'Tâche', key: 'Tâche' },
        { header: 'Type de charge', key: 'Type de charge' },
        { header: 'Libellé', key: 'Libellé' },
        { header: 'Montant', key: 'Montant' },
    ];
    const data = reports.map(r => ({
        Date: r.charge_date,
        Utilisateur: `${r.first_name ?? ''} ${r.last_name ?? ''}`.trim(),
        Tâche: r.task_title,
        'Type de charge': r.charge_label,
        Libellé: r.label,
        Montant: r.amount,
    }));
    const total = reports.reduce((sum, r) => sum + (r.amount ?? 0), 0);
    if (reports.length > 0) {
        data.push({
            Date: '',
            Utilisateur: '',
            Tâche: '',
            'Type de charge': '',
            Libellé: 'Total',
            Montant: total,
        });
    }
    worksheet.addRows(data);
    worksheet.columns.forEach(col => {
        const key = col.key;
        const lengths = data.map(row => String(row[key] ?? '').length);
        const maxLength = Math.max(col.header.length, ...lengths);
        col.width = maxLength + 2;
    });
    styleHeader(worksheet.getRow(1));
    if (reports.length > 0) {
        styleTotalRow(worksheet.getRow(data.length + 1));
    }
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer]);
    const defaultFileName = `Rapport-charges-${formatTimestamp(new Date())}.xlsx`;
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName ?? defaultFileName;
    link.click();
    URL.revokeObjectURL(link.href);
}
